import api from './client';

export interface GenerateNativeRequest {
  vertical: string;
  languages: string[];
  count: number;
  generate_icons: boolean;
  generate_titles: boolean;
  generate_bodies: boolean;
  generate_cta: boolean;
  icon_style: string;
  icon_prompt?: string;
  platforms: string[];
}

export interface GeneratedVariation {
  id: string;
  language: string;
  geos: string[];
  ad_text: string | null;
  ad_body: string | null;
  cta_text: string | null;
  icon_url: string | null;
}

export interface BulkCreateRequest {
  campaign_id: string;
  click_url: string;
  platforms: string[];
  variations: Omit<GeneratedVariation, 'id'>[];
}

export async function getGeoMap(): Promise<Record<string, string[]>> {
  return api.get<Record<string, string[]>>('/admin/generate/geo-map');
}

export async function generateNative(data: GenerateNativeRequest): Promise<GeneratedVariation[]> {
  return api.post<GeneratedVariation[]>('/admin/generate/native', data);
}

export async function regenerateText(data: {
  vertical: string;
  language: string;
  geos: string[];
  field: 'ad_text' | 'ad_body' | 'cta_text';
  platforms: string[];
}): Promise<{ text: string }> {
  return api.post<{ text: string }>('/admin/generate/native/regenerate-text', data);
}

export async function regenerateIcon(data: {
  vertical: string;
  icon_style: string;
  icon_prompt?: string;
}): Promise<{ icon_url: string }> {
  return api.post<{ icon_url: string }>('/admin/generate/native/regenerate-icon', data);
}

export async function bulkCreateAds(data: BulkCreateRequest): Promise<{ created: number; ad_ids: string[] }> {
  return api.post<{ created: number; ad_ids: string[] }>('/admin/generate/native/bulk-create', data);
}

// ===== POPUP GENERATION =====

export interface GeneratePopupRequest {
  vertical: string;
  languages: string[];
  count: number;
  generate_titles: boolean;
  generate_subtitles: boolean;
  generate_button1: boolean;
  generate_button2: boolean;
  platforms: string[];
}

export interface GeneratedPopupVariation {
  id: string;
  language: string;
  geos: string[];
  ad_text: string | null;
  ad_body: string | null;
  cta_text: string | null;
  cta_text_2: string | null;
}

export interface PopupBulkCreateRequest {
  campaign_id: string;
  click_url: string;
  popup_delay_sec: number;
  popup_repeat_sec: number;
  platforms: string[];
  variations: Omit<GeneratedPopupVariation, 'id'>[];
}

export async function generatePopup(data: GeneratePopupRequest): Promise<GeneratedPopupVariation[]> {
  return api.post<GeneratedPopupVariation[]>('/admin/generate/popup', data);
}

export async function regeneratePopupText(data: {
  vertical: string;
  language: string;
  geos: string[];
  field: 'ad_text' | 'ad_body' | 'cta_text' | 'cta_text_2';
  platforms: string[];
}): Promise<{ text: string }> {
  return api.post<{ text: string }>('/admin/generate/popup/regenerate-text', data);
}

export async function bulkCreatePopupAds(data: PopupBulkCreateRequest): Promise<{ created: number; ad_ids: string[] }> {
  return api.post<{ created: number; ad_ids: string[] }>('/admin/generate/popup/bulk-create', data);
}
